import qs from 'qs'

import { ContactBalance, ContactBalanceQueryProps } from '@features/contactBalance'

import { getRequest } from '../../utils'

export interface FetchCreditorsResponseData {
  data: ContactBalance[]
}

export const fetchCreditors = ({
  acceptLanguage,
  date,
  organizationId,
  page,
  pageSize,
  searchQuery,
  sortProperty,
  sortDirection,
}: ContactBalanceQueryProps): Promise<FetchCreditorsResponseData> => {
  const queryParams = qs.stringify({
    ...(acceptLanguage ? { acceptLanguage } : {}),
    ...(date ? { date } : {}),
    ...(page ? { page } : {}),
    ...(pageSize ? { pageSize } : {}),
    ...(searchQuery ? { search: searchQuery } : {}),
    ...(sortProperty ? { sortBy: sortProperty } : {}),
    ...(sortDirection ? { sortDirection } : {}),
  })

  return getRequest(`/v2/organizations/${organizationId}/creditorList.json?${queryParams}`)
}
